<template>
    <div>
        <TopBar :navBack="navBackHandler" :title="lbl.detail.detail" data-cy="component_campaign_topbar"></TopBar>
        <div class="page campaign-detail" v-if="isLoaded && campaign != null" data-cy="container_campaign_page">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mx-5 gap-y-6">
                <div class="mt-5">
                    <Picture :campaign="campaign" data-cy="component_campaign_picture"></Picture>
                </div>
                <div>
                    <DetailInfo :campaign="campaign" data-cy="component_campaign_detail_info"></DetailInfo>
                    <DetailAndCondition :campaign="campaign" data-cy="component_campaign_detail_condition"></DetailAndCondition>
                    <div class="mb-8"></div>
                </div>
            </div>
        </div>

        <div
            class="fixed bottom-4 left-0 w-full px-5"
            v-if="isLoaded && campaign != null && !isTypeNews"
            data-cy="container_campaign_redeem_wrapper"
        >
            <RedeemButton
                :detailController="detailController"
                :modalController="modalController"
                data-cy="component_campaign_redeem_button"
                @clickRedeem="clickRedeem()"
            ></RedeemButton>
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper.js';
import { CampaignType } from "@/helper/StaticValue.js";
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import DetailInfo from '../component/DetailInfo.vue';
import Picture from '../component/Picture.vue';
import DetailAndCondition from '../component/DetailAndCondition.vue';
import RedeemButton from '../component/RedeemButton.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin';
import CampaignUseMixin from "@/mixin/CampaignUseMixin.js";
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';

// compsable
import usePageClass from "@/composables/PageClassComposable";

export default {
    name: "Campaign",
    mixins: [ModalMixin, AuthStatusMixin, LocaleMixin, CampaignUseMixin],
    components: {
        TopBar,
        DetailInfo,
        Picture,
        DetailAndCondition,
        RedeemButton,
    },
    data: function () {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,
        };
    },
    computed: {
        isTypeNews: function () {
            if (this.campaign != null && this.campaign.type == CampaignType.News) {
                return true
            }

            return false
        }
    },
    setup: function () {
        const { pageClass, userLevels } = usePageClass()

        return {
            pageClass,
            userLevels
        }
    },
    mounted: function () {
        /**@type {import("@/helper/TrackingHelper").TrackingService} */
        const trackingService = this.tracking

        trackingService.screenName("campaign_detail")
    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: function () {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function () {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = Util.jsonParse(cacheHelper.getCache('isfromlanding'));

            if (formLanding != null) {
                cacheHelper.removeCache('isfromlanding');

                if (formLanding.page == 'wodd') {
                    return;
                }
                var backAmount = (formLanding.page == 'interface') ? -3 : -2;
                history.go(backAmount);
            }
        },
        //#endregion initial

        //#region setup
        setupDetailController: function () {
            this.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                // Util.log("campaign", campaign);
                this.campaign = campaign;

                this.redeemController.initial(this.campaign, this.modalController);
                this.redeemController.showConfirmMarkUsed = this.showConfirmMarkUsed; //set function from mixin CampaignUseMixin.js
                
                this.setRedeemEvent();
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                // this.loadingModal.hide();
            });
        },
        //#endregion setup

        //#region event
        clickRedeem: function () {
            // track before go
            /**@type {import("@/helper/TrackingHelper").TrackingService} */
            const trackingService = this.tracking
            if (this.userLevels.isPlatinum) {
                trackingService.campaign("click_redeem_platinum", "click_redeem_platinum", this.campaign, null)
            } else {
                trackingService.campaign("click_redeem_gold", "click_redeem_gold", this.campaign, null)
            }

            this.$nextTick(() => {
                var selectCampaignId = this.detailController.selectedCampaignId;
                var selectedQuantity = this.detailController.selectedQuantity;
                this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
            })
        },
        setRedeemEvent: function () {
            /**@type {import("@/helper/TrackingHelper").TrackingService} */
            const trackingService = this.tracking

            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                // console.log("click confirm redeem")
                if (this.userLevels.isPlatinum) {
                    trackingService.campaign("campaign_confirm_platinum", "click_campaign_confirm_platinum", this.campaign, null)
                } else {
                    trackingService.campaign("campaign_confirm_gold", "click_campaign_confirm_gold", this.campaign, null)
                }
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                // console.log("click cancel redeem")
                if (this.userLevels.isPlatinum) {
                    trackingService.campaign("campaign_cancel_platinum", "click_campaign_cancel_platinum", this.campaign, null)
                } else {
                    trackingService.campaign("campaign_cancel_gold", "click_campaign_cancel_gold", this.campaign, null)
                }
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = () => {
                // refresh detail
                this.detailController.reinitial().then((campaign) => {
                    this.campaign = campaign;
                    this.onLoadedCampaign();
                }).catch((err) => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                }).finally(() => {
                    // this.loadingModal.hide();
                });
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onRedeemError = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.loadingModal.hide();
                return true;
            };
        },
        //#endregion event

        onLoadedCampaign: function () {
            this.loadingModal.hide();
            this.isLoaded = true

            // set track on loaded campiang detail
            /**@type {import("@/helper/TrackingHelper").TrackingService} */
            const trackingService = this.tracking

            if (this.userLevels.isPlatinum) {
                trackingService.campaign("view_campaign_platinum", "view_campaign_platinum", this.campaign, null)
            } else {
                trackingService.campaign("view_campaign_gold", "view_campaign_gold", this.campaign, null)
            }
        },
        navBackHandler: function () {
            this.$router.replace({
                name: "privilege"
            })
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
